import React, { useState } from 'react';
import { Warehouse, Package } from 'lucide-react';
import { assetPath, imageCaption, visualText } from './serviceVisuals';

export default function ServiceVisual({ image, title, lang, className = '', eager = false, caption = true, isShed = false }) {
  const [failed, setFailed] = useState(false);
  const Icon = isShed ? Warehouse : Package;
  return <div className={`service-visual ${className}`}>
    {image && !failed ? <img src={assetPath(image)} alt={title} loading={eager ? 'eager' : 'lazy'} decoding="async" onError={() => setFailed(true)} />
      : <div className="service-visual-fallback"><Icon size={54} strokeWidth={1} aria-hidden="true" /><span>{title}</span><small>{visualText(['Photo to be confirmed', 'Foto a confirmar', 'Foto por confirmar'], lang)}</small></div>}
    {caption && image && !failed && <small className="service-visual-caption">{imageCaption(lang, image.endsWith('-ai'))}</small>}
  </div>;
}
